import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
//import './Alert.css'; // Import your CSS file for styling

const Alert = ({ message, onYes, onNo }) => {
  const [closed, setClosed] = useState(false);

  const handleYes = () => {
    setClosed(true);
    if (onYes) {
      onYes();
      console.log("onYes Called in Alert");
    }
  };

  const handleNo = () => {
    setClosed(true);
    if (onNo) {
      onNo();
    }
  };

  return !closed ? (
    <div className='custom-alert'>
      <p className='alert-text'>{message}</p>

      {/* <Row className='d-flex justify-content-between'> */}
      <Button className='close-button btn-sm btn-pad' onClick={handleYes}>
        Yes
      </Button>
      <Button className='close-button btn-sm btn-pad' onClick={handleNo}>
        No
      </Button>
      {/* </Row> */}
    </div>
  ) : null;
};

export default Alert;
